export const JWT_COMPANY_UUID_KEY = 'company_divvy_uuid'
export const JWT_CREDIT_APP_ID_KEY = 'credit_application_id'
export const JWT_CREDIT_APP_IDS_KEY = 'credit_application_ids'
export const JWT_LOOKUP_ID_KEY = 'jwt_lookup_id'
export const JWT_EXPIRATION_KEY = 'exp'
export const JWT_SESSION_ID_KEY = 'session_id'
export const JWT_TYPE_KEY = 'type'
